import React, { PureComponent } from 'react'
import { bool, string, func, any } from 'prop-types'
import { Modal as ReacstrapModal, ModalHeader, ModalBody } from 'reactstrap'
import { Text } from 'components'
import './Modal.css'

export class Modal extends PureComponent {
    static propTypes = {
        isOpen: bool.isRequired,
        title: string,
        text: string,
        children: any,
        onDismiss: func,
        className: string
    }

    render() {
        const { isOpen, title, text, children, onDismiss, className, ...otherProps } = this.props

        return (
            <ReacstrapModal className={className} contentClassName="rounded shadow" isOpen={isOpen} toggle={onDismiss} {...otherProps}>
                {title && <ModalHeader toggle={onDismiss} tag="div"><Text dangerouslySetInnerHTML={{ __html: title }} /></ModalHeader>}
                <ModalBody>
                    {text && <Text className="Modal-Text" dangerouslySetInnerHTML={{ __html: text }} />}
                    {children}
                </ModalBody>
            </ReacstrapModal>
        )
    }
}



// WEBPACK FOOTER //
// src/components/Modal/Modal.js